import React from "react";
import splashLogo from "../css/images/logo.png";

export default function Loading({ pulse = true }) {
	return <img id="loading-logo" className={`absolute-center ${pulse ? "" : "no-pulse"}`} src={splashLogo}></img>;
}
